import createApi from "../utils/axiosInstance";

export const getClientNotes = async (userId) => {
  try {
    const api = createApi(true);
    const response = await api.get(`/admin/client-notes/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const addClientNote = async ({ userId, date, notes, progress }) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/admin/client-notes`, {
      userId,
      date,
      notes,
      progress
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateClientNote = async ({ noteId, date, notes, progress }) => {
  try {
    const api = createApi(true);
    const response = await api.put(`/admin/client-notes/${noteId}`, {
      date,
      notes,
      progress
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const deleteClientNote = async (noteId) => {
  try {
    const api = createApi(true);
    const response = await api.delete(`/admin/client-notes/${noteId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
